import { Component, OnInit } from '@angular/core';
import { ConfirmDialogOptions } from './confirm-dialog-options.interface';
import { ConfirmDialogService } from './confirm-dialog.service';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {
	//https://www.c-sharpcorner.com/article/confirm-dialog-in-angular-using-bootstrap-modal/
	
	public message: any;
	public options: ConfirmDialogOptions;

	public defaultOptions:ConfirmDialogOptions = {
		title: 'Are you sure?',
		btn1Title: 'Yes',
		btn1Class: 'btn-secondary',
		btn2Title: 'No',
		btn2Class: 'btn-secondary'
	}

	constructor(
		private _confirmDialogService: ConfirmDialogService,
	) { }

	ngOnInit(): void {
		//console.log('ConfirmDialogComponent.ngOnInit');
		/**
		* This function waits for a message from alert service, it gets 
		* triggered when we call this from any other component 
		*/
		this._confirmDialogService.getMessage()
			.subscribe((message: any) => {
				//console.log('ConfirmDialogComponent.message:', message);
				if(message && message.options) {
					if(!message.options.btn1Title) message.options.btn1Title = this.defaultOptions.btn1Title;
					if(!message.options.btn1Class) message.options.btn1Class = this.defaultOptions.btn1Class;
					if(!message.options.btn2Title) message.options.btn2Title = this.defaultOptions.btn2Title;
					if(!message.options.btn2Class) message.options.btn2Class = this.defaultOptions.btn2Class;
				}
				
				this.message = message;
			});
	
	}

}
